var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"white lighten-2",attrs:{"src":_vm.device(),"aspect-ratio":_vm.aspectRatio(),"contain":""}})}
var staticRenderFns = []

export { render, staticRenderFns }